module.exports = __webpack_public_path__ + "img/6.4c36de52.png";